import currentContent from "@/content/content.json";
import editions from "@/content/editions.json";

export const EDITION_PARAM = "edition";
export const EDITION_KEY = Symbol("edition");
export const CURRENT_YEAR = editions.current;

// Archivní soubory content<rok>.json; "lazy" = každý ročník je samostatný chunk,
// který se stáhne, až když ho návštěvník otevře.
const archiveFiles = require.context(
  "../content",
  false,
  /^\.\/content\d{4}\.json$/,
  "lazy",
);
const archiveFileKey = (year) => `./content${year}.json`;
const existingFiles = new Set(archiveFiles.keys());

/** Povolené archivní ročníky, které mají soubor, od nejnovějšího. */
export const ARCHIVE_YEARS = Object.freeze(
  editions.archive
    .filter(
      ({ year, enabled }) =>
        enabled === true && existingFiles.has(archiveFileKey(year)),
    )
    .map(({ year }) => year)
    .sort((a, b) => b - a),
);

export function editionUrl(year) {
  const url = new URL(window.location.href);
  url.hash = "";
  if (year === CURRENT_YEAR) {
    url.searchParams.delete(EDITION_PARAM);
  } else {
    url.searchParams.set(EDITION_PARAM, String(year));
  }
  return `${url.pathname}${url.search}`;
}

function removeEditionParam() {
  const url = new URL(window.location.href);
  url.searchParams.delete(EDITION_PARAM);
  window.history.replaceState(window.history.state, "", url);
}

function currentEdition() {
  return { year: CURRENT_YEAR, isArchive: false, content: currentContent };
}

export async function loadEdition() {
  const requested = new URLSearchParams(window.location.search).get(
    EDITION_PARAM,
  );
  if (requested === null) return currentEdition();

  const year = /^\d{4}$/.test(requested) ? Number(requested) : NaN;
  if (ARCHIVE_YEARS.includes(year)) {
    try {
      // Lazy require.context vrací přímo obsah JSON (module.exports), ne { default }.
      const content = await archiveFiles(archiveFileKey(year));
      if (content === null || typeof content !== "object" || Array.isArray(content)) {
        throw new TypeError(`content${year}.json neobsahuje objekt.`);
      }
      return { year, isArchive: true, content };
    } catch (error) {
      console.error(`Nepodařilo se načíst ročník ${year}:`, error);
    }
  }

  removeEditionParam();
  return currentEdition();
}
